module.exports = __webpack_public_path__ + "static/media/29ADMSPC6.1fc5ef61.jpg";